import React, { PropsWithChildren } from "react"
import { StaticQuery, graphql } from "gatsby"
import Header from "./header"
import { Logos } from "./Logo"
import SEO from "./seo"
import "./layout.css"
import { useTranslation } from "react-i18next"

interface Props {
  title: string | JSX.Element,
  subtitle?: string,
  logo: Logos,
  showFooter?: boolean,
  titleWidth?: number,
  productTitle?: string
}

const Layout = ({ children, title, subtitle, logo, showFooter = true, titleWidth = 450, productTitle }: PropsWithChildren<Props>) => {

  const { t } = useTranslation('common')

  return <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={() => (
      <>
        <Header logo={logo} />
        <SEO title={t('layout.title')} productTitle={productTitle} />
        <div
          style={{
            margin: `0 auto`,
            maxWidth: 960,
            padding: `0px 1.0875rem 1.45rem`,
            paddingTop: 0,
          }}
        >
          <main>
            <div
              style={{
                margin: `0 auto`,
                maxWidth: titleWidth,
                padding: `0px 1.0875rem 7.45rem`,
                paddingTop: 0,
                textAlign: 'center'
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                <h1>{title}</h1>
                <p>{subtitle}</p>
              </div>
              {children}
              {showFooter && <footer className="footer">
                <div style={{ margin: '0 auto', maxWidth: 800 }}>
                  <div>{t('layout.disclaimer')}</div>
                </div>
              </footer>}
            </div>
          </main>
        </div>
      </>
    )}
  />
}

export default Layout
